<div class="dynamic-grid-container">
    <!-- Toolbar -->

    @if(showToolbar() === true) {
        <p-toolbar class="mb-3">
            <ng-template #start>
                @if (facade.hasMultipleSelection()) {
                    <div class="mx-2">
                        <p-buttongroup>                        
                            @if(facade.hasSelectableRows()) {
                                <p-button icon="pi pi-check-square" label="Select All" (click)="selectAll()" pTooltip="Select all visible rows" tooltipPosition="top" />
                            }
                            @if(selectedItems().length !== 0) {
                                <p-button icon="pi pi-times" label="Clear Selection" (click)="clearSelection()" pTooltip="Clear Selection" tooltipPosition="top" outlined />
                            }
                        </p-buttongroup>
                    </div>
                }

                <!-- Add Button -->
                @if(shouldShowAddButton()
                    && isButtonVisible(gridSettings().addButtonDetails)) {
                    @if(gridSettings().addButtonDetails.showIcon === true 
                        && gridSettings().addButtonDetails.iconClass) {
                        <p-button 
                            [icon]="gridSettings().addButtonDetails.iconClass" 
                            [label]="gridSettings().addButtonDetails.label" 
                            [variant]="gridSettings().addButtonDetails.buttonVariant || 'outlined'"
                            [size]="gridSettings().addButtonDetails.size || 'small'"
                            [raised]="gridSettings().addButtonDetails.raised || false"
                            [rounded]="gridSettings().addButtonDetails.rounded || false"
                            [disabled]="isButtonDisabled(gridSettings().addButtonDetails)"
                            [class]="gridSettings().addButtonDetails.buttonClass || ''"
                            [pTooltip]="gridSettings().addButtonDetails.tooltip || ''"
                            [tooltipPosition]="gridSettings().addButtonDetails.tooltipPosition || 'top'" 
                            (onClick)="onCommandClicked(true, gridSettings().addButtonDetails.commandType || 'add', $event, gridSettings().addButtonDetails.onClick)" />
                    } @else {
                        <p-button 
                            [label]="gridSettings().addButtonDetails.label" 
                            [variant]="gridSettings().addButtonDetails.buttonVariant || 'outlined'"
                            [size]="gridSettings().addButtonDetails.size || 'small'"
                            [raised]="gridSettings().addButtonDetails.raised || false"
                            [rounded]="gridSettings().addButtonDetails.rounded || false"
                            [disabled]="isButtonDisabled(gridSettings().addButtonDetails)"
                            [class]="gridSettings().addButtonDetails.buttonClass || ''"
                            [pTooltip]="gridSettings().addButtonDetails.tooltip || ''"
                            [tooltipPosition]="gridSettings().addButtonDetails.tooltipPosition || 'top'" 
                            (onClick)="onCommandClicked(true, gridSettings().addButtonDetails.commandType || 'add', $event, gridSettings().addButtonDetails.onClick)" />
                    }
                    
                }

                @if (facade.isRowExpansionEnabled()) {
                    <div class="mx-2">
                        <p-buttongroup>                        
                            <p-button icon="pi pi-plus" label="Expand All" (click)="facade.expandAllRows()" pTooltip="Expand all rows" tooltipPosition="top" />
                            <p-button icon="pi pi-minus" label="Collapse All" (click)="facade.collapseAllRows()" pTooltip="Collapse all rows" tooltipPosition="top" outlined />
                        </p-buttongroup>
                    </div>
                }

                <div>
                    <p-button [outlined]="true" icon="pi pi-filter-slash" size="small" label="Clear Filters" (click)="clear(dt)"pTooltip="Clear Filters" tooltipPosition="top" />
                </div>
            </ng-template>
            
            <ng-template #center>
                <div class="d-flex">
                    <p-iconField>
                        <p-inputIcon class="pi pi-search" />
                        <input pInputText type="text" 
                            [(ngModel)]="searchValue" 
                            (input)="applyGlobalFilter($any($event.target).value)" 
                            [placeholder]="gridSettings().searchPlaceholder || 'Search...'" />
                    </p-iconField>
                </div>
                
            </ng-template>

            
            
            <ng-template #end>
                <p-button icon="pi pi-cog" label="Manage Columns" (click)="openColumnManager()" pTooltip="Manage Columns" aria-label="Column Manager" tooltipPosition="top" styleClass="p-button-sm p-button-text" />

                @if (gridSettings().export.enabled) {
                    
                    <!-- Optional: Quick export button for power users -->
                    @if(selectedItems().length > 0) {
                        <p-button [outlined]="true" 
                            icon="pi pi-download" 
                            size="small" 
                            label="Quick Export Selected" 
                            (click)="quickExportSelected()" 
                            [badge]="selectedItems().length.toString()"
                            badgeClass="p-badge-info"
                            pTooltip="Export selected items with current settings" />
                    }

                    <!-- Export Options -->
                    <app-lt-split-button
                        [options]="exportSplitOptions"
                        (buttonClick)="handleGeneralExport()"
                        text="Export"
                        icon="output"
                        variant="outlined"
                    ></app-lt-split-button>
                }
            </ng-template>
        </p-toolbar>
    }

    <!-- Filter Summary Bar -->
    @if(hasActiveFilters()) {
        <div class="filter-summary-bar mb-2 p-2 bg-primary-50 border-primary-200 border-1 border-round">
            <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center gap-2">
                    <i class="pi pi-filter text-primary"></i>
                    <span class="text-sm">{{ getFilterSummary() }}</span>
                    <span class="text-xs text-500">
                        ({{ getFilteredCount() }} of {{ getOriginalData().length }} records)
                    </span>
                </div>
                <p-button icon="pi pi-filter-slash" 
                          size="small" 
                          [text]="true" 
                          (click)="clearAllFilters()" 
                          pTooltip="Clear all active filters" />
            </div>
        </div>
    }
    
    <p-table #dt class="lt-table"
        [rowHover]="true"
        [value]="displayData()"
        [columns]="visibleColumns()"
        [loading]="loading()"
        [paginator]="gridSettings().pagination.enabled || true"
        [rows]="gridSettings().pagination.rows || 10"
        [rowsPerPageOptions]="gridSettings().pagination.rowsPerPageOptions || [10, 25, 50]"
        [showCurrentPageReport]="gridSettings().pagination.showCurrentPageReport || true"
        [currentPageReportTemplate]="gridSettings().pagination.currentPageReportTemplate"
        [globalFilterFields]="gridSettings().globalFilterFields || []"
        [sortMode]="gridSettings().sortMode || 'single'"
        [multiSortMeta]="multiSortMeta"
        [tableStyle]="gridSettings().tableStyle"
        [tableStyleClass]="gridSettings().tableClass"
        [resizableColumns]="gridSettings().resizableColumns || false"
        [reorderableColumns]="gridSettings().reorderableColumns || false"
        [scrollable]="gridSettings().scrollable || false"
        [virtualScroll]="gridSettings().virtualScroll || false"
        [lazy]="gridSettings().lazy || false"
        [selection]="selectedItems()"
        [selectionMode]="facade.getSelectionMode()"
        (selectionChange)="onSelectionChange($event)"
        (onRowSelect)="onRowSelect($event)"
        (onRowUnselect)="onRowUnselect($event)"
        (onFilter)="onFilter($event)"
        [dataKey]="gridSettings().dataKey"
        styleClass="p-datatable-gridlines"
        [exportFilename]="gridSettings().export.fileName"
        [exportHeader]="gridSettings().export.header"
        [showGridlines]="gridSettings().showGridlines"
        [stripedRows]="gridSettings().stripedRows"
        [expandedRowKeys]="expandedRows()"
        columnResizeMode="expand"
        [frozenColumns]="frozenColumns()"
        responsiveLayout="scroll"
        [size]="gridSettings().tableSize || 'small'"
        [totalRecords]="displayData().length">

        <ng-template pTemplate="header" let-columns>

            <!-- calc header structure -->
             @let headerStructure = getHeaderStructure();
             @let maxDepth = headerStructure.maxDepth;

             @for (headerRow of headerStructure.headerRows; track $index; let rowIndex = $index) {
                <tr>
                    <!-- Selection column header -->
                    @if (facade.showSelectionColumn() && rowIndex === 0) {
                        <th class="selection-column-header-width text-center align-middle" 
                            [attr.rowspan]="maxDepth + gridSettings().hasFilterRow() ? 2 : 1" 
                            [ngStyle]="{ 'width': '2rem', 'min-width': '2rem' }">
                            @if(facade.hasMultipleSelection() && facade.shouldShowSelectAll()) {
                                @switch(facade.getSelectionType()){
                                    @case('checkbox'){
                                        <p-tableHeaderCheckbox />
                                    }
                                    @case('button') {
                                        <p-button type="button" 
                                            text 
                                            size="small"    
                                            icon="pi pi-check" 
                                            (click)="toggleSelectAll()" 
                                            [disabled]="!facade.hasSelectableRows()"
                                            pTooltip="Toggle Select All" />
                                    }
                                    @default {
                                        <mat-icon>select_check_box</mat-icon>
                                    }
                                }
                            }
                        </th>
                    }

                    <!-- Expand Column -->
                    @if (facade.isRowExpansionEnabled() && rowIndex === 0){
                        <th class="expansion-column-header-width text-center align-middle" 
                        [attr.rowspan]="maxDepth + gridSettings().hasFilterRow() ? 2 : 1"
                        [ngStyle]="{ 'width': '50px', 'min-width': '50px' }">
                            <mat-icon>expand</mat-icon>
                        </th>
                    }

                    <!-- Frozen Left Header Cells -->
                    @for(col of getColumnsForHeaderRow(headerRow, 'left'); track col.field) {
                        <th [ngStyle]="{ 'width': col.width, 'min-width': col.minWidth }" 
                            [class]="facade.concatenateClassNames(col.headerStyleClass, 'frozen-left-column')"
                            [attr.colspan]="getColumnSpan(col)"
                            [attr.rowspan]="facade.calculateRowspan(col, maxDepth, rowIndex)"
                            [pSortableColumn]="col.sortable ? col.field : null"
                            [pResizableColumn]="gridSettings().resizableColumns"
                            [pReorderableColumn]="gridSettings().reorderableColumns && col.canReorder ? col.field : null"
                            [pTooltip]="getHeaderTooltipText(col.title, col.tooltip)" tooltipPosition="top">
                            <div class="d-flex align-items-center gap-2">
                                <!-- Header Title or Template -->
                                <ng-container
                                    [ngTemplateOutlet]="plainHeaderText"
                                    [ngTemplateOutletContext]="{
                                        column: col
                                    }">
                                </ng-container>

                                @if(col.sortable && !col.children?.length) {
                                    <p-sortIcon [field]="col.field" class="ms-1" />
                                }
                                @if (col.frozen) {
                                    <i class="pi pi-lock text-blue-500" pTooltip="Frozen Left" tooltipPosition="top"></i>
                                }

                                @if (col.filterable !== false && !col.children?.length && gridSettings().showFilterMenu()) {
                                    <p-columnFilter 
                                        [type]="facade.getFilterType(col)"
                                        [field]="col.field"
                                        [showMatchModes]="col.showFilterMatchModes || true"
                                        [hideOnClear]="col.hideFilterOnClear || true"
                                        [matchMode]="col.defaultMatchMode || 'contains'"
                                        class="ms-1"
                                        [filterOn]="'input'"
                                        display="menu"/>
                                }
                            </div>
                            
                        </th>
                    }

                    <!-- Dynamic Header Cells -->
                    @for(col of getColumnsForHeaderRow(headerRow, 'scrollable'); track col.field) {
                        <th [ngStyle]="{ 'width': col.width, 'min-width': col.minWidth }"
                            [class]="facade.concatenateClassNames(col.headerStyleClass, 'scrollable-column')"
                            [attr.colspan]="getColumnSpan(col)"
                            [attr.rowspan]="facade.calculateRowspan(col, maxDepth, rowIndex)"
                            [pSortableColumn]="col.sortable ? col.field : null"
                            [pResizableColumn]="gridSettings().resizableColumns"
                            [pReorderableColumn]="gridSettings().reorderableColumns && col.canReorder ? col.field : null"
                            [pTooltip]="getHeaderTooltipText(col.title, col.tooltip)" tooltipPosition="top">
                            <div class="d-flex align-items-center gap-2">
                                <!-- Header Title or Template -->
                                <ng-container
                                    [ngTemplateOutlet]="plainHeaderText"
                                    [ngTemplateOutletContext]="{
                                        column: col
                                    }">
                                </ng-container>

                                @if(col.sortable && !col.children?.length) {
                                    <p-sortIcon [field]="col.field" class="ms-1" />
                                }
                                
                                @if (col.filterable !== false && !col.children?.length && gridSettings().showFilterMenu()) {
                                    <p-columnFilter 
                                        [type]="facade.getFilterType(col)"
                                        [field]="col.field"
                                        [showMatchModes]="col.showFilterMatchModes || true"
                                        [hideOnClear]="col.hideFilterOnClear || true"
                                        [matchMode]="col.defaultMatchMode || 'contains'"
                                        class="ms-1"
                                        [filterOn]="'input'"
                                        display="menu"/>
                                }
                            </div>                        
                        </th>
                    }

                    <!-- Frozen Right Header Cells -->
                    @for(col of getColumnsForHeaderRow(headerRow, 'right'); track col.field) {
                        <th [ngStyle]="{ 'width': col.width, 'min-width': col.minWidth }"
                            [class]="facade.concatenateClassNames(col.headerStyleClass, 'frozen-right-column')"
                            [attr.colspan]="getColumnSpan(col)"
                            [attr.rowspan]="facade.calculateRowspan(col, maxDepth, rowIndex)"
                            [pSortableColumn]="col.sortable ? col.field : null"
                            [pResizableColumn]="gridSettings().resizableColumns"
                            [pReorderableColumn]="gridSettings().reorderableColumns && col.canReorder ? col.field : null"
                            [pTooltip]="getHeaderTooltipText(col.title, col.tooltip)" tooltipPosition="top">
                            <div class="d-flex align-items-center gap-2">
                                <!-- Header Title or Template -->
                                <ng-container
                                    [ngTemplateOutlet]="plainHeaderText"
                                    [ngTemplateOutletContext]="{
                                        column: col
                                    }">
                                </ng-container>

                                @if(col.sortable && !col.children?.length) {
                                    <p-sortIcon [field]="col.field" class="ms-1" />
                                }

                                @if(col.frozen) {
                                    <i class="pi pi-lock text-orange-500" pTooltip="Frozen Right" tooltipPosition="top"></i>
                                }

                                @if (col.filterable !== false && !col.children?.length && gridSettings().showFilterMenu()) {
                                    <p-columnFilter 
                                        [type]="facade.getFilterType(col)"
                                        [field]="col.field"
                                        [showMatchModes]="col.showFilterMatchModes || true"
                                        [hideOnClear]="col.hideFilterOnClear || true"
                                        [matchMode]="col.defaultMatchMode || 'contains'"
                                        class="ms-1"
                                        [filterOn]="'input'"
                                        display="menu"/>
                                }
                            </div>
                            
                        </th>
                    }

                    <!-- Action Column -->
                    @if(gridSettings().actionColumn.enabled === true && rowIndex === 0)
                    {
                        <th class="action-column-header-width text-center align-middle" 
                            [attr.rowspan]="maxDepth + gridSettings().hasFilterRow() ? 2 : 1">
                            {{ gridSettings().actionColumn.headerText || 'Go To' }}
                        </th>
                    }

                    <!-- Command Column -->
                    @if(gridSettings().commandsColumn.enabled === true && rowIndex === 0)
                    {
                        <th class="commands-column-header-width text-center align-middle" 
                            [attr.rowspan]="gridSettings().hasFilterRow() ? 2 : 1">
                            {{ gridSettings().commandsColumn.headerText || 'Commands' }}
                        </th>
                    }
                </tr>
             }

            <!-- Filter Row -->
            @if(gridSettings().hasFilterRow()) {
                <tr>
                    <!-- Selection and Expansion columns are handled by rowspan above -->

                    <!-- Frozen Left Filter Cells (only leaf columns) -->
                    @for(col of getLeafColumns('left'); track col.field) {
                        @if (col.filterable === false) {
                            <th [ngStyle]="{ 'width': col.width, 'min-width': col.minWidth }"></th>
                        } @else {
                            <th [ngStyle]="{ 'width': col.width, 'min-width': col.minWidth }">
                                @if (facade.getCellTemplate(col.field + 'Filter'); as filterTemplate) {
                                    <ng-container 
                                        [ngTemplateOutlet]="filterTemplate"
                                        [ngTemplateOutletContext]="{ $implicit: col, column: col}"></ng-container>
                                } @else if (col.filterTemplate) {
                                    <ng-container 
                                        [ngTemplateOutlet]="col.filterTemplate"
                                        [ngTemplateOutletContext]="{ $implicit: col, column: col}"></ng-container>
                                } @else {
                                    <p-columnFilter 
                                        [type]="facade.getFilterType(col)"
                                        [field]="col.field"
                                        [showMatchModes]="col.showFilterMatchModes || true"
                                        [hideOnClear]="col.hideFilterOnClear || true"
                                        [matchMode]="col.defaultMatchMode || 'contains'"
                                        showClearButton="false"
                                        [filterOn]="'input'"
                                        display="row" />
                                }
                            </th>
                        }
                    }

                    <!-- Scrollable Filter Cells (only leaf columns) -->
                    @for(col of getLeafColumns('scrollable'); track col.field) {
                        @if (col.filterable === false) {
                            <th [ngStyle]="{ 'width': col.width, 'min-width': col.minWidth }"></th>
                        } @else {
                            <th [ngStyle]="{ 'width': col.width, 'min-width': col.minWidth }">
                            
                                @if (facade.getCellTemplate(col.field + 'Filter'); as filterTemplate) {
                                    <ng-container 
                                        [ngTemplateOutlet]="filterTemplate"
                                        [ngTemplateOutletContext]="{ $implicit: col, column: col}"></ng-container>
                                } @else if (col.filterTemplate) {
                                    <ng-container 
                                        [ngTemplateOutlet]="col.filterTemplate"
                                        [ngTemplateOutletContext]="{ $implicit: col, column: col}"></ng-container>
                                } @else {
                                    <p-columnFilter 
                                        [type]="facade.getFilterType(col)"
                                        [field]="col.field"
                                        [showMatchModes]="col.showFilterMatchModes || true"
                                        [hideOnClear]="col.hideFilterOnClear || true"
                                        [matchMode]="col.defaultMatchMode || 'contains'"
                                        showClearButton="false"
                                        [filterOn]="'input'"
                                        display="row" />
                                    
                                }
                            </th>
                        }
                    }

                    <!-- Frozen Right Filter Cells (only leaf columns) -->
                    @for(col of getLeafColumns('right'); track col.field) {
                        @if (col.filterable === false) {
                            <th [ngStyle]="{ 'width': col.width, 'min-width': col.minWidth }"></th>
                        } @else {
                            <th [ngStyle]="{ 'width': col.width, 'min-width': col.minWidth }">
                            
                                @if (facade.getCellTemplate(col.field + 'Filter'); as filterTemplate) {
                                    <ng-container 
                                        [ngTemplateOutlet]="filterTemplate"
                                        [ngTemplateOutletContext]="{ $implicit: col, column: col}"></ng-container>
                                } @else if (col.filterTemplate) {
                                    <ng-container 
                                        [ngTemplateOutlet]="col.filterTemplate"
                                        [ngTemplateOutletContext]="{ $implicit: col, column: col}"></ng-container>
                                } @else {
                                    <p-columnFilter 
                                        [type]="facade.getFilterType(col)"
                                        [field]="col.field"
                                        [showMatchModes]="col.showFilterMatchModes || true"
                                        [hideOnClear]="col.hideFilterOnClear || true"
                                        [matchMode]="col.defaultMatchMode || 'contains'"
                                        showClearButton="false"
                                        [filterOn]="'input'"
                                        display="row" />
                                    
                                }
                            </th>
                        }
                    }
                    
                    <!-- Action Column and Command Column handled by rowspan above -->
                </tr>
            }
            
        </ng-template>

        <!-- Table Body Template -->
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex" let-expanded="expanded">
            <tr 
                [class.p-highlight]="facade.isRowSelected(rowData)"
                [class.selected-row]="facade.isRowSelected(rowData)"
                (click)="onRowClick(rowData, $event)">

                <!-- Selection Cell -->
                 @if (facade.showSelectionColumn()) {
                    <td class="text-center align-middle">

                        @switch(facade.getSelectionType()) {
                            @case('checkbox'){
                                <p-tableCheckbox [value]="rowData" />
                            }
                            @case('radio'){
                                <p-tableRadioButton [value]="rowData" />
                            }
                            @case('button') {
                                @if(gridSettings().selection.text && gridSettings().selection.text !== '') {
                                    <p-button type="button" 
                                        text 
                                        size="small"
                                        [styleClass]="facade.isRowSelected(rowData) ? 'p-button-success p-button-sm' : 'p-button-outlined p-button-sm'"
                                        [icon]="facade.isRowSelected(rowData) ? 'pi pi-check' : 'pi pi-plus'"
                                        (click)="toggleRowSelection(rowData, !facade.isRowSelected(rowData))"
                                        [label]="gridSettings().selection.text"
                                        [pTooltip]="facade.isRowSelected(rowData) ? 'Deselect' : 'Select'" />
                                } @else {
                                    <p-button type="button" 
                                        text 
                                        size="small"
                                        [styleClass]="facade.isRowSelected(rowData) ? 'p-button-success p-button-sm' : 'p-button-outlined p-button-sm'"
                                        [icon]="facade.isRowSelected(rowData) ? 'pi pi-check' : 'pi pi-plus'"
                                        (click)="toggleRowSelection(rowData, !facade.isRowSelected(rowData))"
                                        [pTooltip]="facade.isRowSelected(rowData) ? 'Deselect' : 'Select'" />
                                }
                            }
                            @default {
                               <p-button rounded
                                    icon="{{gridSettings().selection.iconClass || 'pi pi-check'}}" 
                                    [styleClass]="facade.isRowSelected(rowData) ? 'p-button-success p-button-sm' : 'p-button-outlined p-button-sm'"
                                    (click)="toggleRowSelection(rowData, !facade.isRowSelected(rowData))"
                                    [class]="gridSettings().selection.buttonClass || 'p-button-sm p-button-outlined'" 
                                    [disabled]="isSelectionDisabled(rowData)" />
                            }
                        }
                    </td>
                }

                <!-- Row Expansion Cell -->
                @if (facade.isRowExpansionEnabled()) {
                    <td class="text-center align-middle">
                        <button matIconButton 
                            pTooltip="Toggle details" 
                            tooltipPosition="left" pRipple
                            showDelay="1000" hideDelay="300"
                            (click)="facade.toggleRowExpansion(rowData, $event)">
                            @if(expanded) {
                                <mat-icon>keyboard_arrow_up</mat-icon>
                            } @else {
                                <mat-icon>keyboard_arrow_down</mat-icon>
                            }
                        </button>
                    </td>
                }

                <!-- Frozen Left Data Cells -->
                @for(col of getLeafColumns('left'); track $index)
                {
                    <td [class]="facade.concatenateClassNames(col.bodyStyleClass)">
                        <ng-container
                            [ngTemplateOutlet]="plainCell"
                            [ngTemplateOutletContext]="{
                                rowData: rowData, 
                                column: col, 
                                rowIndex: rowIndex
                            }">
                        </ng-container>
                    </td>
                }

                <!-- Dynamic Data Cells -->
                @for(col of getLeafColumns('scrollable'); track $index)
                {
                    <td [class]="facade.concatenateClassNames(col.bodyStyleClass, 'scrollable-column')">
                        <ng-container
                            [ngTemplateOutlet]="plainCell"
                            [ngTemplateOutletContext]="{
                                rowData: rowData, 
                                column: col, 
                                rowIndex: rowIndex
                            }">
                        </ng-container>
                    </td>
                }

                <!-- Frozen Right Data Cells -->
                @for(col of getLeafColumns('right'); track $index)
                {
                    <td [class]="facade.concatenateClassNames(col.bodyStyleClass)">
                        <ng-container
                            [ngTemplateOutlet]="plainCell"
                            [ngTemplateOutletContext]="{
                                rowData: rowData, 
                                column: col, 
                                rowIndex: rowIndex
                            }">
                        </ng-container>
                    </td>
                }

                @if(gridSettings().actionColumn.enabled === true)
                {
                    <td #actionCol class="text-center align-middle">
                        @if(gridSettings().actionColumn.onSelectionChange) {
                            <a [routerLink]="gridSettings().getRouterLink(rowData)" target="_blank">
                                <p-button 
                                    type="button" 
                                    label="Navigate" 
                                    [class]="gridSettings().actionColumn.buttonClass || 'p-button-sm p-button-outlined'" 
                                    rounded
                                    (click)="gridSettings().handleActionClick($event, rowData)"/>
                            </a>
                        } @else {
                            <a [routerLink]="gridSettings().getRouterLink(rowData)" target="_blank">
                                <p-button 
                                    type="button" 
                                    label="Navigate" 
                                    [class]="gridSettings().actionColumn.buttonClass || 'p-button-sm p-button-outlined'" 
                                    rounded
                                    (click)="gridSettings().stopPropagation($event, rowData)"/>
                            </a>
                        }
                    </td>
                }

                @if(gridSettings().commandsColumn.enabled === true)
                {
                    <td #commandsCol class="text-center align-middle" [style.width]="'100px'">
                        <div class="d-flex flex-column gap-2"
                            [class.flex-column]="gridSettings().commandsColumn.layout !== 'horizontal'"
                            [class.flex-row]="gridSettings().commandsColumn.layout === 'horizontal'"
                            [style.gap]="gridSettings().commandsColumn.buttonSpacing || '0.5rem'">

                            @for(button of gridSettings().commandsColumn.buttons; track button.commandType){
                                @if(isButtonVisible(button, rowData)) {
                                    <!-- Button with Icon -->
                                    @if(button.showIcon === true && button.iconClass) {
                                         <p-button 
                                                [icon]="button.iconClass" 
                                                [label]="button.label" 
                                                [variant]="button.buttonVariant || 'outlined'"
                                                [size]="button.size || 'small'"
                                                [raised]="button.raised || false"
                                                [rounded]="button.rounded || false"
                                                [disabled]="isButtonDisabled(button, rowData)"
                                                [class]="button.buttonClass || ''"
                                                [pTooltip]="button.tooltip || ''"
                                                [tooltipPosition]="button.tooltipPosition || 'top'" 
                                                (onClick)="onCommandClicked(rowData, button.commandType, $event, button.onClick)" />
                                    } @else {
                                        <p-button 
                                            [label]="button.label" 
                                            [variant]="button.buttonVariant || 'outlined'"
                                            [size]="button.size || 'small'"
                                            [raised]="button.raised || false"
                                            [rounded]="button.rounded || false"
                                            [disabled]="isButtonDisabled(button, rowData)"
                                            [class]="button.buttonClass || ''"
                                            [pTooltip]="button.tooltip || ''"
                                            [tooltipPosition]="button.tooltipPosition || 'top'" 
                                            (onClick)="onCommandClicked(rowData, button.commandType, $event, button.onClick)" />
                                     }
                                }
                            }
                            @empty {
                                <!-- no buttons to show -->
                            }
                        </div>
                    </td>
                }
            </tr>
        </ng-template>

        @if(facade.hasColumnAggregates()) {
            <ng-template pTemplate="footer">
                <tr class="p-datatable-footer">

                    <!-- Selection column footer -->
                    @if (facade.showSelectionColumn()) {
                        <td class="text-center align-middle footer-cell">
                            <app-lt-png-table-selection-footer [selectedCount]="selectedItems().length"></app-lt-png-table-selection-footer>
                        </td>
                    }

                    <!-- Expansion column footer -->
                    @if (facade.isRowExpansionEnabled()) {
                        <td class="text-center align-middle footer-cell">
                            <app-lt-png-table-expansion-footer [expandedCount]="facade.getExpandedCount()"></app-lt-png-table-expansion-footer>
                        </td>
                    }

                    <!-- Frozen Left Footer Cells -->
                    @for(col of getLeafColumns('left'); track col.field) {
                        <td class="footer-cell frozen-left-column" 
                            [ngStyle]="{ 'width': col.width, 'min-width': col.minWidth }">
                            <ng-container
                                [ngTemplateOutlet]="plainAggCell"
                                [ngTemplateOutletContext]="{
                                    column: col
                                }">
                            </ng-container>
                        </td>
                    }

                    <!-- Scrollable Footer Cells -->
                    @for(col of getLeafColumns('scrollable'); track col.field) {
                        <td class="footer-cell scrollable-column" 
                            [ngStyle]="{ 'width': col.width, 'min-width': col.minWidth }">
                            <ng-container
                                [ngTemplateOutlet]="plainAggCell"
                                [ngTemplateOutletContext]="{
                                    column: col
                                }">
                            </ng-container>
                        </td>
                    }

                    <!-- Frozen Right Footer Cells -->
                    @for(col of getLeafColumns('right'); track col.field) {
                        <td class="footer-cell frozen-right-column" 
                            [ngStyle]="{ 'width': col.width, 'min-width': col.minWidth }">
                            <ng-container
                                [ngTemplateOutlet]="plainAggCell"
                                [ngTemplateOutletContext]="{
                                    column: col
                                }">
                            </ng-container>
                        </td>
                        
                    }

                    <!-- Action Column Footer -->
                    @if(gridSettings().actionColumn.enabled === true) {
                        <td class="text-center align-middle footer-cell">
                            <app-lt-png-table-action-footer [rowCount]="displayData().length"></app-lt-png-table-action-footer>
                        </td>
                    }

                    <!-- Commands Column Footer -->
                    @if(gridSettings().commandsColumn.enabled === true) {
                        <td class="text-center align-middle footer-cell">
                            <app-lt-png-table-action-footer [rowCount]="displayData().length"></app-lt-png-table-action-footer>
                        </td>
                    }
                </tr>
            </ng-template>
        }
        
        <!-- Empty Message -->
        <ng-template pTemplate="emptymessage">
            <tr>
                <td class="text-center p-4" [attr.colspan]="gridSettings().getColspan()">
                    <div class="empty-state">
                        <i class="pi pi-info-circle text-4xl text-gray-400 mb-3"></i>
                        <p class="text-gray-600 text-lg mb-2">{{ gridSettings().emptyStateMessage || 'No records found' }}</p>
                        @if(hasActiveFilters()) {
                            <p class="text-gray-400 text-sm">Try adjusting your filters or search criteria</p>
                        } @else {
                            <p class="text-gray-400 text-sm">No data available to display</p>
                        }
                    </div>
                </td>
            </tr>
        </ng-template>

        <!-- Row Expansion Template -->
        @if (facade.isRowExpansionEnabled()) {
          <ng-template #expandedrow let-rowData let-rowIndex="rowIndex">
            @if (facade.getExpandTemplate(); as expandTemplate) {
              <tr>
                <td [attr.colspan]="gridSettings().getColspan()">
                  <div class="p-3 border-round bg-surface-50">
                    <ng-container 
                      [ngTemplateOutlet]="expandTemplate"
                      [ngTemplateOutletContext]="{ $implicit: rowData, rowIndex: rowIndex, data: rowData }"
                    />
                  </div>
                </td>
              </tr>
            }
          </ng-template>
        }

    </p-table>
</div>

<app-lt-column-manager
    [visible]="showColumnManager()"
    (visibleChange)="toggleColumnManager($event)"
    [columns]="gridSettings().columns"
    (columnsChange)="onColumnsChange($event)">
</app-lt-column-manager>

<ng-template #plainAggCell let-column="column">
    <app-lt-column-aggregate
        [column]="column"
        [data]="displayData()"
        [showIcons]="true"
        [showPlaceholder]="false"
        [placeholderText]="'—'"
        [templateResolver]="facade.getTemplateResolver()">
    </app-lt-column-aggregate>
</ng-template>

<ng-template #plainCell let-rowData="rowData" let-col="column" let-rowIdx="rowIndex">
    <app-lt-png-table-cell
        [rowData]="rowData"
        [column]="col"
        [rowIndex]="rowIdx"
        [value]="facade.getFieldValue(rowData, col)"
        [cellTemplates]="templateMap()">
    </app-lt-png-table-cell>
</ng-template>

<ng-template #plainHeaderText let-col="column">
    <!-- @if (getCellTemplate(col.field + 'Header'); as headerTemplate) { -->
    @if (facade.getCellTemplate(col.field + 'Header'); as headerTemplate) {
        <ng-container 
            [ngTemplateOutlet]="headerTemplate"
            [ngTemplateOutletContext]="{ $implicit: col, column: col}"></ng-container>
    } @else if (col.headerTemplate) {
        <ng-container 
            [ngTemplateOutlet]="col.headerTemplate"
            [ngTemplateOutletContext]="{ $implicit: col, column: col}"></ng-container>
    } @else {
        @if(col.tooltipData) {
            <span [pTooltip]="col.tooltipData" tooltipPosition="top">{{ col.header }}</span>
        } @else {
            <span>{{ col.header }}</span>
        }
    }
</ng-template>

<app-lt-export-manager
    [visible]="showExportManager()"
    (visibleChange)="toggleExportManager($event)"
    [gridFacade]="facade"
    [config]="exportManagerConfig"
    (exportCompleted)="onExportCompleted($event)"
    (exportCancelled)="onExportCancelled()">
</app-lt-export-manager>